var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('email-form',{attrs:{"model":_vm.email,"titlePrefix":_vm.$t('emails-create.texts.title-prefix')},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }